import React from 'react';
import GenericMenu from './source/GenericMenuProject';
import { SLUGS } from 'src/enum/permissions.enum';

const LIST_MENU = {
  primary: [
    { check: SLUGS.FACILITY.READ_ALL, to: '/facility', primary: 'Объекты' },
    { check: SLUGS.CATALOG.WORKER.READ, to: '/worker', primary: 'Работники' },
    { check: SLUGS.CATALOG.PROVIDER.READ, to: '/provider', primary: 'Поставщики' },
    { check: SLUGS.CATALOG.READ, to: '/companies', primary: 'Компании' },
    { check: SLUGS.CATALOG.READ, to: '/work-estimate', primary: 'Работы смета' },
    { check: SLUGS.CATALOG.READ, to: '/machine', primary: 'Техника' },
  ],
  secondary: [
    { check: SLUGS.CATALOG.READ, to: '/storageunit', primary: 'Единица хранения' },
    { check: SLUGS.CATALOG.EQUIPMENT.READ, to: '/equipment', primary: 'Материалы Оборудование' },
    { check: SLUGS.CATALOG.READ, to: '/worktemplate', primary: 'Шаблон работ для наряда' },
    { check: SLUGS.CATALOG.READ, to: '/position', primary: 'Должности' },
    { check: SLUGS.CATALOG.READ, to: '/resources', primary: 'Ресурсы' },
  ],
  settings: [
    { check: SLUGS.USER.READ, to: '/users', primary: 'Пользователи' },
    { check: SLUGS.CATALOG.READ, to: '/templates', primary: 'Шаблоны отчетов' },
    { check: SLUGS.CATALOG.READ, to: '/checklist', primary: 'Контрольные листы' },
  ]
}
const LIST_SECTION = {
  primary: 'Общие',
  settings: 'Настройки',
  secondary: 'Остальное',
}
export default function ListMenu(props) {
  return (
    <GenericMenu
      menuConfig={LIST_MENU}
      sectionsMap={LIST_SECTION}
      propsRouter={props}
    />
  );
}